import { connect } from 'react-redux';
import { fetchReviewStatsIfNeeded } from 'marketing/ducks';
import ReviewsAggMetadata from 'marketing/components/reviews_agg_metadata';

const mapStateToProps = ({ marketing }) => {
  return {
    stats: marketing.reviewStats
  };
}

export default connect(mapStateToProps, { fetchReviewStatsIfNeeded })(ReviewsAggMetadata);
